import React from 'react';

import useProcessedVideo from '../../hooks/useProcessedVideo';

export default function BytescaleVideo({ videoPath, onClick, className }) {
  const { videoUrl, isLoading, error } = useProcessedVideo(videoPath, true);

  if (isLoading) {
    return (
      <div
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f0f0f0',
        }}
      >
        <span>Loading video...</span>
      </div>
    );
  }

  if (error || !videoUrl) {
    return (
      <div
        className={className}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f0f0f0',
        }}
      >
        <span>Unable to load video</span>
      </div>
    );
  }

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video controls muted className={className} onClick={onClick} autoPlay playsInline>
      <source src={videoUrl} type="video/mp4" />
      {`Your browser does not support the video tag. Filename: ${videoPath}`}
    </video>
  );
}
